<rid-demo-page [title]="'Lezen basis'" previousRoute="/mechanics">
  <div class="flex flex-col gap-2">
    <rid-button
      class="w-full"
      content="Lezen basis | Instructiemodus (per klank)"
      variant="PRIMARY"
      routerLink="instruction-mode-per-sound"
      [queryParams]="{ pace: 500 }"
    />
    <rid-button
      class="w-full"
      content="Lezen basis | Instructiemodus (per klankvoet)"
      variant="PRIMARY"
      routerLink="instruction-mode-per-soundfoot"
      [queryParams]="{ pace: 500 }"
    />
    <rid-button
      class="w-full"
      content="Lezen basis | Instructiemodus (per woord)"
      variant="PRIMARY"
      routerLink="instruction-mode-per-word"
      [queryParams]="{ pace: 500 }"
    />
  </div>
  <div class="flex flex-col gap-2">
    <rid-button
      class="w-full"
      content="Lezen basis | Huiswerkmodus (per klank)"
      variant="PRIMARY"
      routerLink="homework-mode-per-sound"
      [queryParams]="{ pace: 500, pause: 1000 }"
    />
    <rid-button
      class="w-full"
      content="Lezen basis | Huiswerkmodus (per klankvoet)"
      variant="PRIMARY"
      routerLink="homework-mode-per-soundfoot"
      [queryParams]="{ pace: 500, pause: 1000 }"
    />
    <rid-button
      class="w-full"
      content="Lezen basis | Huiswerkmodus (per woord)"
      variant="PRIMARY"
      routerLink="homework-mode-per-word"
      [queryParams]="{ pace: 500, pause: 1000 }"
    />
  </div>
  <rid-button class="w-full" content="Lezen basis | Focuslezen" variant="PRIMARY" routerLink="focus" [queryParams]="{ pace: 200 }" />
  <rid-button class="w-full" content="Lezen basis | Mistlezen" variant="PRIMARY" routerLink="fog" [queryParams]="{ pace: 200 }" />
</rid-demo-page>
